export default "__VITE_ASSET__CO6XW4yz__"